import request from 'lib/request';

export interface Response {
  code: number;
  data?: null;
  msg: string;
}

export async function setNotRemindMint(not_remind_mint: boolean) {
  const res = await request<Response>('/user_profile/not_remind_mint_again', {
    method: 'POST',
    data: {
      not_remind_mint,
    },
  });
  return res;
}
